import { UI, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  coesFixedIncomeProductsQuery,
  coesEquityProductsQuery,
} from '../../../../../../store/managementAnalysisDetails/selector';
import { DynamicProductTable } from '../../DynamicProductTable';
import { ProductTableProps } from '../../DynamicProductTable/constants';
import { tableHead as tableHeadFixedIncome } from '../fixed-income/constants';
import ProductItemFixedIncome from '../fixed-income/item';

import { getCoesFilters, tableHead as tableHeadEquity } from './constants';
import ProductItemEquity from './item';

export const CoesTable = (props: ProductTableProps) => {
  const [activeTab, setActiveTab] = React.useState(0);

  const handleChangeTab = (tabIndex: number) => {
    props.setDataLength(0);
    setActiveTab(tabIndex);
  };

  const renderCorrectTabTable = () => {
    if (activeTab === 0) {
      return (
        <DynamicProductTable
          {...props}
          key="coes-fixed-income"
          ProductItem={ProductItemFixedIncome}
          productsQuery={coesFixedIncomeProductsQuery}
          productsFiltersGetter={getCoesFilters}
          tableHeadItems={tableHeadFixedIncome}
          tabletColumns={4}
          mobileFields={[
            { key: 'customerNormalized', label: 'Cliente' },
            { key: 'issuerNormalized', label: 'Emissor' },
            { key: 'assetNormalized', label: 'Ativo' },
            { key: 'formattedIndexRateNormalized', label: 'Taxa/ind.' },
            { key: 'indexNormalized', label: 'Índice' },
            { key: 'availableQuantity', label: 'Quantidade disponível' },
            { key: 'blockedQuantityNormalized', label: 'Quantidade bloqueada' },
            { key: 'totalQuantityNormalized', label: 'Quantidade total' },
            { key: 'maturityDateNormalized', label: 'Vencimento' },
            { key: 'grossValueNormalized', label: 'Valor bruto' },
            { key: 'positionDateNormalized', label: 'Data da posição' },
            { key: 'purchaseDateNormalized', label: 'Data da compra' },
            { key: 'purchaseValueNormalized', label: 'Valor compra' },
            { key: 'iofValueNormalized', label: 'Valor IOF' },
            { key: 'irValueNormalized', label: 'Valor IR' },
            { key: 'netValueNormalized', label: 'Valor líquido' },
          ]}
        />
      );
    }

    return (
      <DynamicProductTable
        {...props}
        key="coes-equity"
        ProductItem={ProductItemEquity}
        productsQuery={coesEquityProductsQuery}
        productsFiltersGetter={getCoesFilters}
        tableHeadItems={tableHeadEquity}
        tabletColumns={4}
        mobileFields={[
          { key: 'customerNameNormalized', label: 'Cliente' },
          { key: 'assetNameNormalized', label: 'Ativo' },
          { key: 'startDateNormalized', label: 'Data inicio' },
          { key: 'maturityDateNormalized', label: 'Vencimento' },
          { key: 'appliedValueNormalized', label: 'Valor aplicado' },
          { key: 'currentValueNormalized', label: 'Valor atual' },
          { key: 'markValueNormalized', label: 'Valor de marcação' },
          { key: 'returnFormatted', label: 'Retorno', indicatorKey: 'returnNormalized' },
        ]}
      />
    );
  };

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <UI.Tabs
        testId="coes-type-tabs"
        activeTab={activeTab}
        onTabPress={handleChangeTab}
        tabs={[{ title: 'Operações em Renda Fixa' }, { title: 'Operações em Renda Variável' }]}
      />
      {renderCorrectTabTable()}
    </VStack>
  );
};
